"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollToTopButtomComponent = exports.ScrollToTopButtomComponent = void 0;
const app_1 = require("app");
class ScrollToTopButtomComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.scroll-to-top';
        this.headerSelector = '.header';
        this.headerElement = null;
        this.OnInit = () => {
            if (this.el[0]) {
                this.insertTopIdElement();
                this.scrollToTopBtn = this.el[0];
                this.scrollToTopBtn.addEventListener('click', this.onClick);
                this.headerElement = document.querySelector(this.headerSelector);
            }
        };
        this.onClick = (event) => {
            var _a;
            event.preventDefault();
            this.scrollToTopBtn.setAttribute('href', '#top');
            window.scrollTo({ top: 0, behavior: 'smooth' });
            (_a = this.headerElement) === null || _a === void 0 ? void 0 : _a.classList.remove('max-md:-translate-y-full');
        };
        this.insertTopIdElement = () => {
            const bodyElement = document.body;
            const topElement = document.createElement('div');
            topElement.id = 'top';
            bodyElement.prepend(topElement);
        };
    }
    OnScrollThrottle() {
        if (document.body.scrollTop > 1000 || document.documentElement.scrollTop > 1000) {
            if (!this.isVisible) {
                this.scrollToTopBtn.classList.add('animated');
                this.isVisible = true;
                globalThis.location.hash === '#top' && app_1.UrlService.RemoveHash();
            }
        }
        else if (this.isVisible) {
            this.scrollToTopBtn.classList.remove('animated');
            this.isVisible = false;
        }
    }
}
exports.ScrollToTopButtomComponent = ScrollToTopButtomComponent;
exports.scrollToTopButtomComponent = new ScrollToTopButtomComponent();
